import AppForm from "components/AppForm/AppForm";
import CrudPage from "components/CrudPage/CrudPage";
import { withRemoteDataAndSpinner } from "hoc/withRemoteDataAndSpinner";
import withRouter from "hoc/withRouter";
import { useLoadAll } from "hooks/useLoadAll";
import membersService from "services/admin/membersService";
import inputTypeEnum from "enums/inputTypes";
import { snack } from "components/Snack/Snack";
import rolesAdminService from "services/admin/rolesService";
import branchesAdminService from "services/admin/branchesService";
import categoriesAdminService from "services/admin/categoriesService";

const MemberForm = ({
  router: {
    navigate,
    params: { id },
  },
  data: { member, roles, branches, categories },
}) => {
  /**
   * Скорей всего нужно перевести данные о сотрудника в плоский формат
   */
  const fieldsWithData = [
    {
      key: "name",
      label: "ФИО(полностью как указан в удостоверение личности)",
      required: true,
      placeholder: 'Введите ФИО пользователя',
      inputType: inputTypeEnum.text,
    },
    {
      key: "user.email",
      label: "Email",
      inputType: inputTypeEnum.email,
    },
    {
      key: "user.phone",
      label: "Телефон (в формате 77472001991)",
      required: true,
      inputType: inputTypeEnum.text,
    },
    {
      key: "branchID",
      label: "Филиал",
      inputType: inputTypeEnum.select,
      options: branches ? branches.data : [],
      multiple: false,
      required: true
    },
    // categoryID
    {
      key: "categoryID",
      label: "Тематика обращения",
      inputType: inputTypeEnum.select,
      options: categories ? categories.data : [],
      multiple: false,
      required: true
    },
    {
      key: "roleID",
      label: "Роли",
      inputType: inputTypeEnum.select,
      options: roles,
      multiple: false,
      required: true
    },
    {
      key: "canProcessOrder",
      label: "Автоматически назначать менеджером для новых заказов",
      inputType: inputTypeEnum.checkbox,
    },
    {
      key: "connectedWhatsapp",
      label: "Статус подключения Whatsapp",
      inputType: inputTypeEnum.checkbox,
      defaultValue: false,
    },
  ];

  const onSubmit = async (formInput) => {
    try {
      if (member) {
        await membersService.put(id, formInput)
        snack("Сотрудник обновлен успешно!");
      } else {
        await membersService.post(formInput)
        snack("Сотрудник создан успешно!");
      }

      setTimeout(() => {
        navigate(-1);
      }, 1000);
    } catch (ex) {
      console.error(ex)
    }
  };

  return (
    <CrudPage title={member ? 'Редактирование сотрудника' : 'Создание сотрудника'}>
      <AppForm onSubmit={onSubmit} data={member} fields={fieldsWithData}></AppForm>
    </CrudPage>
  );
};
export default withRouter(
  withRemoteDataAndSpinner(MemberForm, (router) => {
    let requests = {
      roles: rolesAdminService.getAll,
      branches: branchesAdminService.getAll,
      categories: () => categoriesAdminService.getAll({ type: 'TICKET' }),
    }
    if (router.params.id) {
      requests['member'] = () => membersService.get(router.params.id)
    }
    return useLoadAll(requests);
  })
);
